import Component from 'gia/Component';
import Swiper from 'swiper';
import { gsap } from 'gsap';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export default class ArticleCarousel extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      swiper: {}
    };
  }

  mount() {
    let that = this;

    const swiper = new Swiper(this.ref.swiper, {
      // configure Swiper to use modules
      modules: [Navigation],
      navigation: {
        nextEl: '.c--next',
        prevEl: '.c--prev',
      },
      slidesPerView: 1,
      spaceBetween: 30,
      breakpoints: {
        640: {
          slidesPerView: 1.4,
          spaceBetween: 32,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
        768: {
          slidesPerView: 2.4,
          spaceBetween: 32,
          slidesOffsetBefore: 32,
          slidesOffsetAfter: 32,
        },
        768: {
          slidesPerView: 2.4,
          spaceBetween: 48,
          slidesOffsetBefore: 48,
          slidesOffsetAfter: 48,
        }
      },

      speed: 1000,
    });

  }


}